<template>
  <div class="grid__tile--grid">
    <div v-for="dataItem in data" class="grid__tile">
      <span class="grid__data">{{ dataItem.data }}</span>
      <span class="grid__label">{{ dataItem.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tile-grid',
  props: ['data']
}
</script>



// WEBPACK FOOTER //
// TileGrid.vue?b24e8ad8